import React from 'react';
import { string } from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Row, Col } from '@thd-olt-component-react/grid';
import { InstantChekoutTooltip } from './InstantChekoutTooltip';

const InstantCheckoutEnroll = ({ channel }) => {
  return (
    <div className="instant-checkout">
      <div className="instant-checkout__wrapper">
        <div className="instant-checkout__box">
          <Row>
            <Col>
              <div>
                <span className="instant-checkout__heading">Your Fastest Checkout</span>
                <Tooltip
                  channel={channel}
                  placement="bottom"
                  closeButton
                  content={<InstantChekoutTooltip />}
                  interactive
                >
                  <span className="instant-checkout__info" />
                </Tooltip>
              </div>
            </Col>
            <Col nopadding>
              <span>
                <a href="/account/view/instantcheckout" className="u__default-link">Turn on Instant Checkout</a>
              </span>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
InstantCheckoutEnroll.propTypes = {
  channel: string
};

InstantCheckoutEnroll.defaultProps = {
  channel: 'desktop'
};

export { InstantCheckoutEnroll };